import { connect } from 'react-redux'
import LiveEnabledModal from './LiveEnabledModal'
import { State } from '../../dataStore/reducers/reducerType'
import { LiveEnabledModalProps } from './types'

const mapStateToProps = (state: State): Omit<LiveEnabledModalProps, 'history' | 'match'> => {

  const webcast = state.webcast.collection[`${state.config.channelId}${state.config.webcastId}`]
  return {
    status: state.ui.status,
    date: webcast && webcast.status.hasData ? webcast.data.start : '',
    dismissed: state.ui.hideItsTime
  }

}

export default connect(mapStateToProps)(LiveEnabledModal)
